export class SlotController {
    constructor(host, ...slotNames) {
        this.slotNames = [];
        this.handleSlotChange = (event) => {
            const slot = event.target;
            if ((this.slotNames.includes('[default]') && !slot.name) ||
                (slot.name && this.slotNames.includes(slot.name))) {
                this.host.requestUpdate();
            }
        };
        (this.host = host).addController(this);
        this.slotNames = slotNames;
    }
    hostConnected() {
        this.host.shadowRoot.addEventListener('slotchange', this.handleSlotChange);
    }
    hostDisconnected() {
        this.host.shadowRoot.removeEventListener('slotchange', this.handleSlotChange);
    }
    hasSlot(slot) {
        return slot === '[default]' ? this.hasDefaultSlot() : this.hasNamedSlot(slot);
    }
    hasDefaultSlot() {
        return [...this.host.childNodes].some((node) => {
            if (node.nodeType === node.TEXT_NODE && node.textContent.trim() !== '') {
                return true;
            }
            if (node.nodeType === node.ELEMENT_NODE) {
                const el = node;
                // The default slot doesn't have a slot attribute
                if (!el.hasAttribute('slot')) {
                    return true;
                }
            }
            return false;
        });
    }
    hasNamedSlot(name) {
        return this.host.querySelector(`:scope > [slot="${name}"]`) !== null;
    }
}
//# sourceMappingURL=slot.controller.js.map